import { Badge, Box, Button, Tooltip } from '@mantine/core';
import { useInvoiceSelection } from 'app/Private/Clients/Detail/UnhandledInvoicesTab/use-invoice-selection';
import { tKeys, useTranslation } from 'locales/index';
import { isNullish } from 'remeda';
import { aiRecommendedBorderClass } from './ActionButton.styles';
import type { ActionButtonDefinition } from './use-build-action-buttons';

type ActionButtonProps = {
  definition: ActionButtonDefinition;
};

export const ActionButton = ({ definition }: ActionButtonProps) => {
  const {
    icon,
    translationKey,
    onClick,
    isEnabled,
    recommended,
    eligibleInvoiceIds,
    disabledReason,
  } = definition;
  const { t } = useTranslation();

  const { selectedInvoiceIds, setHoveredInvoiceIds } = useInvoiceSelection();
  const isAiRecommended = recommended === 'AI';
  const isDisabled = !isEnabled || selectedInvoiceIds.length === 0;

  return (
    <Tooltip label={disabledReason} disabled={isNullish(disabledReason)}>
      <Box
        miw={0}
        className={isAiRecommended ? aiRecommendedBorderClass : undefined}
        style={{ overflow: 'visible' }}
        data-disabled={isDisabled ? true : undefined}
        onMouseEnter={() => setHoveredInvoiceIds(eligibleInvoiceIds)}
        onMouseLeave={() => setHoveredInvoiceIds([])}
      >
        <Button
          variant="default"
          w="100%"
          leftSection={icon}
          disabled={isDisabled}
          onClick={onClick}
          style={
            isAiRecommended
              ? {
                  overflow: 'visible',
                  border: 'none',
                  boxShadow: 'none',
                  width: '100%',
                  backgroundColor: 'var(--mantine-color-violet-0)',
                }
              : undefined
          }
        >
          {isAiRecommended && (
            <Badge
              size="xs"
              variant="gradient"
              gradient={{ from: 'violet', to: 'pink' }}
              style={{ position: 'absolute', top: -8, right: -8, zIndex: 1 }}
            >
              {t(tKeys.AI_SUMMARY.RECOMMENDED_BADGE)}
            </Badge>
          )}
          {t(translationKey)}
        </Button>
      </Box>
    </Tooltip>
  );
};
